import { NotificationMessages } from '../types';

export const notificationSW: NotificationMessages = {
    'app.notification.title': 'Kituo cha Arifa',
    "app.notification.generate_file": "Tunaunda faili lako. Mara litakapokuwa tayari, utapokea arifa ya kulipakua.",
    'app.notification.download_program': 'Pakua Maelezo ya Mpango',
};
